import { createSlice } from "@reduxjs/toolkit";
import { WHATSAPP_CONFIG } from "../../../constants/reducer_names";



const initialState: any = {
    configData:{}
} as any;

const whatsappConfigSlice = createSlice({
    name: WHATSAPP_CONFIG,
    initialState,
    reducers: {
        setConfigData: (state, { payload }) => {
            state.configData={...payload}
        }
    }
});


export const WhatsappConfigActions = whatsappConfigSlice.actions;
export default whatsappConfigSlice.reducer;



